import { IInterview } from 'app/shared/model/interview.model';

export interface IRecordedInterview {
  id?: number;
  recordedInterviewId?: string | null;
  interview?: IInterview | null;
}

export const defaultValue: Readonly<IRecordedInterview> = {};
